'use client'

import { cn } from '@utils'

export default function MenuButton({
  className,
  size = 'medium',
  open = false,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: 'small' | 'medium' | 'large'
  open?: boolean
}) {
  const isSmall = size === 'small'
  const isMedium = size === 'medium'
  const isLarge = size === 'large'
  return (
    <button
      type='button'
      className={cn(
        'relative text-white cursor-pointer',
        { 'w-5 h-4': isSmall },
        { 'w-6 h-4': isMedium },
        { 'w-7 h-5': isLarge },
        className
      )}
      {...props}
    >
      <Line className={open ? 'top-1/2 -translate-y-1/2 rotate-45' : 'top-0'} />
      <Line className={open ? 'hidden' : 'top-1/2 -translate-y-1/2'} />
      <Line
        className={open ? 'top-1/2 -translate-y-1/2 -rotate-45' : 'bottom-0'}
      />
    </button>
  )
}

function Line({ className }: { className?: string }) {
  return (
    <i
      className={cn(
        'block absolute left-0 w-full h-0.5 bg-current transition-all',
        className
      )}
    />
  )
}
